import React, { useMemo } from "react";
import DOMPurify from "dompurify";

/**
 * Safely renders limited inline HTML returned by the API.
 * Allowed tags: b, strong, i, em, u, br
 * Everything else gets stripped.
 */
export const RichText: React.FC<{ htmlOrText: string }> = ({ htmlOrText }) => {
  // If API sends plain text with \n, convert to <br> for nicer wrapping.
  const prepped = useMemo(() => {
    const looksLikeHtml = /<[^>]+>/.test(htmlOrText);
    return looksLikeHtml ? htmlOrText : htmlOrText.replace(/\n/g, "<br/>");
  }, [htmlOrText]);

  const sanitized = useMemo(() => {
    return DOMPurify.sanitize(prepped, {
      ALLOWED_TAGS: ["b", "strong", "i", "em", "u", "br"],
      ALLOWED_ATTR: [],
      // Keep it tight. If you later need links, allow <a> with rel="noopener"
    });
  }, [prepped]);

  return <span dangerouslySetInnerHTML={{ __html: sanitized }} />;
};
